import React, { useState } from 'react';
import { Mail, Zap, CheckCircle, TrendingUp } from 'lucide-react';
import '../CSS/Newsletter.css';

const Newsletter = () => {
  const [email, setEmail] = useState('');
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

const handleSubscribe = async (e) => {
  e.preventDefault();
  setIsLoading(true);

  try {
    const res = await fetch('https://api.aikanksha.com/api/subscribe', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ email })
    });

    if (!res.ok) throw new Error('Subscription failed');

    setIsSubscribed(true);
    setEmail('');
  } catch (err) {
    console.error(err);
    alert('Subscription failed. Please try again.');
  } finally {
    setIsLoading(false);
  }
};



  const benefits = [
    {
      icon: Zap,
      title: 'Weekly AI Updates',
      description: 'Latest AI tools, trends, and breakthroughs delivered to your inbox'
    },
    {
      icon: TrendingUp,
      title: 'Exclusive Insights',
      description: 'Behind-the-scenes content and strategies not shared anywhere else'
    },
    {
      icon: CheckCircle,
      title: 'Actionable Tips',
      description: 'Practical AI implementation guides you can use immediately'
    }
  ];

  return (
    <section id="newsletter" className="newsletter">
      <div className="newsletter-header">
        <div className="newsletter-label">
          <Mail size={16} className="text-primary" />
          FastFeedAI Newsletter
        </div>
        <h2>
          Get AI updates straight to your <span>inbox</span>
        </h2>
        <p>
          Join 1,000+ professionals who stay ahead of the AI curve with weekly insights,
          tool recommendations, and exclusive content.
        </p>
      </div>

      <div className="newsletter-features">
        {benefits.map((benefit, index) => (
          <div key={benefit.title} className="newsletter-feature">
            <div className="newsletter-feature-icon">
              <benefit.icon size={20} />
            </div>
            <h3>{benefit.title}</h3>
            <p>{benefit.description}</p>
          </div>
        ))}
      </div>

      {isSubscribed ? (
        <div className="success-message">
          <CheckCircle size={32} className="text-green-500" />
          <h3>Welcome to FastFeedAI</h3>
          <p>Thank you for subscribing. Check your inbox for a welcome email with exclusive AI resources.</p>
        </div>
      ) : (
        <form onSubmit={handleSubscribe} className="newsletter-form">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Enter your email address"
            required
            className="newsletter-input"
          />
          <button type="submit" disabled={isLoading} className="newsletter-button">
            {isLoading ? 'Subscribing...' : 'Subscribe'}
          </button>
        </form>
      )}

      <div className="newsletter-note">
        <span>1,000+ subscribers</span> • <span>Weekly content</span> • <span>Free to join</span>
      </div>
    </section>
  );
};

export default Newsletter;
